'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editor = exports.syllabusStore = exports.syllabusActions = undefined;

var _actions = require('./actions');

var _actions2 = _interopRequireDefault(_actions);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _editor2 = require('./editor');

var _editor3 = _interopRequireDefault(_editor2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.syllabusActions = _actions2.default;
exports.syllabusStore = _store2.default;
exports.editor = _editor3.default;


//////////////////
// WEBPACK FOOTER
// ./syllabus/index.js
// module id = 609
// module chunks = 0